import { render, staticRenderFns } from "./creatTemplates.vue?vue&type=template&id=506acf58&scoped=true"
import script from "./creatTemplates.vue?vue&type=script&lang=js"
export * from "./creatTemplates.vue?vue&type=script&lang=js"
import style0 from "./creatTemplates.vue?vue&type=style&index=0&id=506acf58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506acf58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506acf58')) {
      api.createRecord('506acf58', component.options)
    } else {
      api.reload('506acf58', component.options)
    }
    module.hot.accept("./creatTemplates.vue?vue&type=template&id=506acf58&scoped=true", function () {
      api.rerender('506acf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/logistics/shippingTemplates/creatTemplates.vue"
export default component.exports